import PropTypes from "prop-types";
import * as React from "react";

export default function PageMain({ fallback, children }) {
  return (
    <main id="main" tabIndex={-1}>
      <React.Suspense fallback={fallback}>{children}</React.Suspense>
    </main>
  );
}

PageMain.propTypes = {
  fallback: PropTypes.node.isRequired,
  children: PropTypes.node,
};
